import { theme } from 'antd'
import { ThemeConfig } from 'antd/lib/config-provider/context'
import { darken, lighten } from 'polished'
import { createContext } from 'react'

export type ThemeCustomizationType = {
  primaryColor?: string
  backgroundColor?: string
  secondaryColor?: string
  dark?: boolean
  manualConfig?: string
  compact?: boolean
  colorBgBase?: string
}

export type ThemeContextValueType = {
  theme: ThemeConfig
  sideMenuTheme: ThemeConfig
  toolbarTheme: ThemeConfig
  customize?: (options: ThemeCustomizationType) => unknown
  customizeSideMenu?: (options: ThemeCustomizationType) => unknown
  customizeToolbar?: (options: ThemeCustomizationType) => unknown
}

export const ThemeContext = createContext<ThemeContextValueType>({
  sideMenuTheme: {},
  theme: {},
  toolbarTheme: {},
})

export const prepareTheme = (options: ThemeCustomizationType = {}): ThemeConfig => {
  if (!options.primaryColor) {
    options.primaryColor = '#EB6435'
  }
  if (!options.backgroundColor) {
    options.backgroundColor = '#fcfaf2'
  }

  if (!options.secondaryColor) {
    options.secondaryColor = 'rgba(0,0,0,0.04)'
  }

  let base: ThemeConfig = {}
  if (options.manualConfig) {
    try {
      base = JSON.parse(options.manualConfig)
    } catch (error) {
      console.error('Failed to apply manual config for theme!')
    }
  }

  return {
    algorithm: [
      options.dark && theme.darkAlgorithm,
      options.compact && theme.compactAlgorithm,
    ].filter((e) => !!e),
    components: {
      ...(base?.components ?? {}),
      Button: {
        colorPrimary: options.primaryColor,
        ...(base?.components?.Button ?? {}),
      },
      Card: {
        fontWeightStrong: 500,
        ...(base?.components?.Card ?? {}),
      },
      Layout: {
        colorBgLayout: options.backgroundColor,
        ...(base?.components?.Layout ?? {}),
      },
      Menu: {
        itemHoverBg: 'transparent',
        itemHoverColor: options.primaryColor,
        ...(base?.components?.Menu ?? {}),
      },
      Segmented: {
        colorBgLayout: options.dark ? 'rgba(255,255,255,.0.4)' : 'rgba(0,0,0,.04)',
        ...(base?.components?.Segmented ?? {}),
      },
    },
    token: {
      borderRadius: 6,
      colorBgLayout: options.backgroundColor,
      colorFillSecondary: options.secondaryColor,
      colorLink: options.primaryColor,
      colorLinkActive: darken(0.1, options.primaryColor),
      colorLinkHover: lighten(0.1, options.primaryColor),
      colorPrimary: options.primaryColor,
      fontFamily: '"Basier Circle", sans-serif',
      fontSize: 16,
      ...(base?.token ?? {}),
    },
  }
}

